import { template } from 'lodash'
import { em } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'

import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { Col, Row } from 'styles/components/layout'

import CartCostBlockNew from '../CartCostBlockNew'

import { CartItemTitleStyled, CostBlock, RowStyled } from './styles'

/**
 * CartDelivery
 *
 * @param {object} props - properties of component
 * @returns {node} CartDelivery
 */
const CartDeliveryAndTotal = ({
  isFree,
  texts,
  isCartInitOrUpdate,
  precision,
  cart,
}) => {
  const {
    currentCountry: { intlCode },
    sales: { currency, delivery: deliveryConfig },
  } = React.useContext(LocalizationContext)
  const { mobile } = React.useContext(ResizeContext)

  const isAlwaysFreeDelivery = !cart.sum.delivery && !deliveryConfig.cost
  const title = React.useMemo(() => {
    const compileTitle = template(
      isFree ? texts.delivery.title_free : texts.delivery.title,
    )
    const placeholder = isCartInitOrUpdate && '...'
    return compileTitle({
      from: placeholder || deliveryConfig.from,
      to: placeholder || deliveryConfig.to,
    })
  }, [isFree, deliveryConfig, texts.delivery, isCartInitOrUpdate])
  return (
    <>
      <Row>
        <Col width={{ md: em(210), lg: em(289) }} flexGrow={{ xs: 1, md: 0 }}>
          <CartItemTitleStyled
            dangerouslySetInnerHTML={{
              __html: mobile ? texts.delivery.row_title : title,
            }}
          />
        </Col>
        <Col width={{ xs: em(85), md: em(125), lg: em(197) }}>
          <CostBlock>
            <CartCostBlockNew
              intlCode={intlCode}
              currencyCode={currency}
              cost={cart.sum.delivery}
              precision={precision}
              realCost={isFree ? deliveryConfig.cost : cart.sum.delivery}
              showCrossedCost={isFree && !isAlwaysFreeDelivery}
              isLoading={isCartInitOrUpdate}
              size="xs"
            />
          </CostBlock>
        </Col>
      </Row>
      <RowStyled>
        <Col width={{ md: em(210), lg: em(289) }} flexGrow={{ xs: 1, md: 0 }}>
          <CartItemTitleStyled
            dangerouslySetInnerHTML={{ __html: texts.total.subtotal }}
          />
        </Col>
        <Col width={{ xs: em(85), md: em(125), lg: em(197) }}>
          <CostBlock>
            <CartCostBlockNew
              intlCode={intlCode}
              currencyCode={currency}
              cost={cart.sum.cost}
              realCost={cart.sum.realCost}
              precision={precision}
              showCrossedCost={cart.sum.realCost !== cart.sum.cost}
              isLoading={isCartInitOrUpdate}
              size="medium"
            />
          </CostBlock>
        </Col>
      </RowStyled>
    </>
  )
}

CartDeliveryAndTotal.propTypes = {
  cart: PropTypes.object,

  /** Cost of delivery is free because of stock condition */
  isFree: PropTypes.bool.isRequired,

  /** Information about goods item */
  texts: PropTypes.object.isRequired,

  /** Is block disabled */
  isDisabled: PropTypes.bool.isRequired,

  /** Hide cost block if cart init or update */
  isCartInitOrUpdate: PropTypes.bool,

  /** Precision of cost */
  precision: PropTypes.number,
}

export default CartDeliveryAndTotal
